export class ClaveValorComponent {
  private id: string;
  private description: string; // La descripcion del campo

  constructor( id: string, description: string ) {
    this.id = id;
    this.description = description;
  }

  public setId (id: string) { this.id = id; }
  public getId () { return this.id; }

  public setDescription (description: string) { this.description = description; }
  public getDescription () { return this.description; }
}



// WEBPACK FOOTER //
// ./src/app/DTOs/ClaveValor.component.ts